import { useEffect } from 'react';

import { postMessageToMobileApp } from 'components/app/helpers';
import { isRNWebview } from 'constants/constants';
import { POST_MESSAGE_TO_MOBILE_EVENTS } from 'constants/enums';

const useFullScreenChangeNotifyApp = () => {
  useEffect(() => {
    const handleFullScreenChange = () => {
      if (document.fullscreenElement != null) {
        postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.FULL_SCREEN_STATUS, {
          isFullScreen: true,
        });
      } else {
        postMessageToMobileApp(POST_MESSAGE_TO_MOBILE_EVENTS.FULL_SCREEN_STATUS, {
          isFullScreen: false,
        });
      }
    };

    if (isRNWebview()) {
      document.addEventListener('fullscreenchange', handleFullScreenChange);
    }

    return () => {
      if (isRNWebview()) {
        document.removeEventListener('fullscreenchange', handleFullScreenChange);
      }
    };
  }, []);
};

export { useFullScreenChangeNotifyApp };
